import React from 'react';
import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface FilterNestedProps {
  onSubmit?: () => void;
  isVisible?: boolean;
  children?: React.ReactNode;
}

const Layout = styled.section<Partial<FilterNestedProps>>`
  position: relative;
  z-index: ${theme.zIndex.filter};
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height 375ms linear;

  > * {
    height: 0;
    max-height: 0;
    margin-bottom: 0;
    transition: max-height 375ms linear;
  }

  ${({ isVisible }) =>
    isVisible &&
    css`
      height: auto;
      max-height: 1000px;
      overflow: visible;

      > * {
        height: auto;
        max-height: 1000px;
      }
    `}
`;

const Form = styled.form`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-gap: ${toRem(22)} ${toRem(22)};
  grid-template-columns: repeat(auto-fit, minmax(${toRem(250)}, 1fr));
  padding: ${toRem(11)} ${toRem(22)};

  > * {
    margin-bottom: 0 !important;
  }
`;

const FilterNested: React.FC<FilterNestedProps> = ({ onSubmit, isVisible, children, ...rest }) => (
  <Layout isVisible={isVisible} data-cy="filter-section" {...rest}>
    <Form onSubmit={onSubmit}>
      <Grid>{children}</Grid>
    </Form>
  </Layout>
);

export default FilterNested;
